import Modal from "@/component/CustomModal";

interface MobileAboutModalProps {
  visible: boolean;
  onCancel: () => void;
}

const MobileAboutModal = (props: MobileAboutModalProps) => {
  const { visible, onCancel } = props;
  const list = [
    {
      label: "用户协议",
      url: "https://account.seewo.com/seewo-account/agreement?appCode=MaxLink-AI-Client&type=1&index=1",
    },
    {
      label: "隐私政策",
      url: "https://account.seewo.com/seewo-account/agreement?appCode=MaxLink-AI-Client&type=0&index=0",
    },
    {
      label: "个人信息收集清单",
      url: "https://account.seewo.com/seewo-account/agreement?appCode=MaxLink-AI-Client&type=1&index=2",
    },
    {
      label: "第三方共享个人信息清单",
      url: "https://account.seewo.com/seewo-account/agreement?appCode=MaxLink-AI-Client&type=1&index=0",
    },
    {
      label: "系统权限使用清单",
      url: "https://account.seewo.com/seewo-account/agreement?appCode=MaxLink-AI-Client&type=1&index=3",
    },
  ];

  return (
    <Modal visible={visible} mask>
      <div className="bg-white w-80 pt-8 rounded-6 relative overflow-hidden">
        <div className="text-#333333 text-4.5 lh-4.5 font-500 text-center mb-4">
          关于
        </div>
        <div className="flex flex-col items-center justify-center">
          {list.map((item) => (
            <div
              key={item.label}
              className="text-mx-primary text-3.5 text-center mb-4"
              onClick={() => window.location.href = item.url}
            >
              {item.label}
            </div>
          ))}
        </div>
        <div className="mt-4 h-13 lh-13 text-center w-full flex items-center b-t-1px b-t-solid b-#000/10 text-4">
          <div className="h-full flex-1 text-#000000" onClick={onCancel}>
            取消
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MobileAboutModal;
